<template>
  <div class="container my-3">
    <div :v-if="mensagemSucesso" v-for="i in mensagemSucesso" :key="i">
      <p>
        <b-alert show variant="success" dismissible>{{ i }}</b-alert>
      </p>
    </div>

    <div :v-if="mensagemErro" v-for="i in mensagemErro" :key="i">
      <p>
        <b-alert show :variant="corMensagem" dismissible>
          <b-icon :variant="corMensagem" :icon="iconMensErro"/>
          {{ i.mensInicio }}
          <a v-if="i.mensLink" :href="i.mensLink" target="_blank">aqui</a>
          {{ i.mensFim }}
        </b-alert>
      </p>
    </div>
    <p></p>
    <div>
      <div style="text-align: center">
        <loading :active.sync="carregando" :is-full-page="true"></loading>
      </div>
      <div>
        <!-- ABA DADOS GERAIS -->
        <form @submit.prevent>
          <h2 class="title">Pesquisar contribuinte</h2>
          <b-card>          
            <b-container fluid>
              <b-row v-if="usuarioAutenticado === true">
                <span
                  class="title h5"
                  v-b-tooltip.hover="{ variant: 'primary', placement: 'right' }"
                  title="Esta pesquisa consulta todos os débitos passíveis de adesão ao programa Reativa BH para um determinado CPF ou pela raíz de um CNPJ"
                >
                  Pesquisar informando os dados do contribuinte
                  <b-icon
                    variant="primary"
                    icon="info-circle-fill"
                    class="ml-2"
                  />
                </span>
              </b-row>

              <b-row class="my-3" v-if="usuarioAutenticado === true">
                <b-col sm="2" md="2" lg="1" align-self="center">
                  <label for="cadastroNacional" class="pb-3">CPF/CNPJ</label>
                </b-col>
                <b-col sm="8" md="4" align-self="start">
                  <b-form-input
                    id="cadastroNacional"
                    class="ml-3"
                    v-mask="['###.###.###-##', '##.###.###/####-##']"
                    @keyup="validacaoCPFCNPJ()"
                    :disabled= "origemAcesso == 'GovBr'"
                    placeholder="Pesquisa completa por CPF/CNPJ"
                    v-model="dadosContribuinte.cadastroNacional"
                  >
                  </b-form-input>
                  <small
                    id="cadastroNacional"
                    :class="erroValidacaoCPFCNPJ"
                    class="ml-3"
                  >
                    {{ mensagemValidacaoCPFCNPJ }}
                  </small>
                </b-col>
              </b-row>
              <b-row class="mb-2 mt-3"  v-if="usuarioAutenticado === true">
                <b-col sm="2" md="2" lg="1" align-self="center">
                  <label for="nomeContribuinte" class="pb-3">Nome</label>
                </b-col>
                <b-col sm="8" md="4" align-self="start">
                  <b-form-input id="nomeContribuinte" class="ml-3"  disabled
                    v-model="dadosContribuinte.nomeContribuinte">
                  </b-form-input>
                </b-col>
              </b-row>              
            </b-container>

            <span
              class="title h5"
              v-b-tooltip.hover="{ variant: 'primary', placement: 'right' }"
              title="Esta pesquisa é uma consulta por filtros, retornando somente os débitos passíveis de adesão ao programa Reativa BH ligados ao identificador específico selecionado"
            >
              Pesquisar informando um identificador específico
              <b-icon variant="primary" icon="info-circle-fill" class="ml-2" />
            </span>

            <b-row class="my-3 mb-2">
              <b-col sm="2" md="2"> </b-col>
              <b-col sm="2" md="2" lg="1" align-self="center">
                <label for="tipoCertidao" class="p-0 mb-0">Opções</label>
              </b-col>
              <b-col sm="5" md="3">
                <b-form-select
                  id="tipoCertidao"
                  class="ml-3 mb-0 mr-sm-2 mb-sm-0"
                  v-model="dadosContribuinte.tipoIdentificador"
                  :options="opcoesIdentificador"
                  :disabled="desabilitaIdentificador"
                  @change="reinicializaIdentificador()"
                >
                </b-form-select>
              </b-col>
              <b-col
                sm="5"
                md="5"
                v-if="dadosContribuinte.tipoIdentificador !== ''"
              >
                <div
                  v-if="
                    dadosContribuinte.tipoIdentificador === 16 ||
                    dadosContribuinte.tipoIdentificador === 14
                  "
                >
                  <b-input-group class="mt-0">
                    <b-form-input
                      id="identificador"
                      type="search"
                      @keyup="preencheIdentificador()"
                      v-model="dadosContribuinte.identificador"
                      @keydown="validacaoIdentificador()"
                      :placeholder="placeHolderIdentificador"
                    >
                    </b-form-input>
                  </b-input-group>
                  <small
                    id="identificador"
                    class="form-text"
                    :class="erroValidacaoIdentificador"
                  >
                    {{ mensagemValidacaoIdentificador }}
                  </small>
                </div>
                <div v-else>
                  <b-input-group class="mt-0">
                    <b-form-input
                      id="identificador"
                      type="search"
                      @keyup="preencheIdentificador()"
                      v-mask="mascaraIdentificador"
                      v-model="dadosContribuinte.identificador"
                      @keydown="validacaoIdentificador()"
                      :placeholder="placeHolderIdentificador"
                    >
                    </b-form-input>
                  </b-input-group>
                  <small
                    id="identificador"
                    class="form-text"
                    :class="erroValidacaoIdentificador"
                  >
                    {{ mensagemValidacaoIdentificador }}
                  </small>
                </div>
              </b-col>
            </b-row>
            <!-- guias -->
            <b-row v-if="!usuarioAutenticado">
              <b-col>
                <span class="font-italic font-weight-bold"> ATENÇÃO: </span>
                Pesquisa por CPF deverá ser feita pelo acesso identificado
                localizado no canto superior direito.
              </b-col>
            </b-row>

            <div v-if="cnpjsRelacionados.length > 0">
              <span class="title h5" v-b-tooltip.hover="{ variant: 'primary', placement: 'right' }"
                title="Lista de CNPJ associados ao CPF logado.">
                Opções para visualizar débitos como representante legal ou
                procurador
                <b-icon variant="primary" icon="info-circle-fill" class="ml-2" />
              </span>

              <b-row class="mt-3 mb-2 mt-0">
                <b-col sm="2" md="2"> </b-col>
                <b-col class="mt-2 mb-2 mt-0" v-for="(estabelecimento, index) in cnpjsRelacionados" :key="index">
                  <b-form-checkbox sm="4" align-self="end" name="cnpjRelacionados" :value="estabelecimento.value"
                    v-model="cnpjSelecionado" stacked
                    @change="montaSelecionado(estabelecimento.cnpj, estabelecimento.razao)">
                    <span class="font-weight-bold">{{
                      estabelecimento.text
                    }}</span>
                  </b-form-checkbox>
                </b-col>
              </b-row>
            </div>

            <b-row class="mb-0 float-right">
              <b-button variant="secondary" class="float-right" @click="() => limparCampos()">
                <span v-if="cnpjsRelacionados.length > 0 && origemAcesso === 'GovBr'
                  ">
                  Retornar para CPF
                </span>
                <span v-else> Limpar </span>
              </b-button>
              <b-button variant="primary" class="ml-3 mr-3 float-right" 
                :disabled="verificaPreenchimento()"
                @click.prevent="() => pesquisar()">
                Pesquisar
              </b-button>
            </b-row>
          </b-card>
   
          <div v-if="mostrarDemaisInformacoes && !mostrarErroMuitosLancamentos">
            <h2 class="title mt-5" v-if="mostrarSelecaoLancamentos === true">
              Seleção de Lançamentos
            </h2>
            <div
              v-if="
                mostrarSelecaoLancamentos === true &&
                listaAgrupamentos.length >= 1
              "
            >
              <b-alert show variant="primary">
                <div>
                  <b-icon variant="primary" icon="info-circle-fill" />
                  Abaixo são apresentadas as opções para emissão de DRAM. Para
                  adesão ao programa Reativa BH deverá ser emitido um DRAM para
                  cada opção de seleção.
                </div>
              </b-alert>
            </div>

            <b-card v-if="mostrarSelecaoLancamentos === true">
              <div>
                <b-form-radio-group
                  class="ml-3"
                  stacked
                  :checked="orgaoCobranca"
                >
                  <b-form-group
                    :value="grupo"
                    v-for="(grupo, index) in listaAgrupamentos"
                    :key="index"
                    :name="grupo.DESCRICAO"
                    class="mb-2"
                  >
                    <span class="font-weight-bolder">{{
                      grupo.DESCRICAO
                    }}</span>
                    <b-form-radio
                      v-for="tipo in grupo.LISTA_NIVEL2"
                      :key="tipo.DESCRICAO"
                      :value="tipo"
                      v-model="orgaoCobranca"
                      :name="tipo.DESCRICAO + index"
                      class="ml-3 mt-2"
                      @change="limparDadosTabela(tipo)"
                    >
                      {{ tipo.DESCRICAO }}
                    </b-form-radio>
                  </b-form-group>
                </b-form-radio-group>

                <b-row class="mr-2 float-right">
                  <b-button
                    variant="primary"
                    :disabled="
                      !orgaoCobranca.ALANCAMENTOS ||
                      bloquearExibirLancamentos === true
                    "
                    @click.prevent="abrirModal('modal-lancamentos')"
                  >
                    Exibir lançamentos
                  </b-button>
                </b-row>
              </div>
            </b-card>
          </div>
          <div class="mt-5" v-else>
          </div>
          <div class="mt-3" v-if="informativoSelecao === true">
            <p>
              <b-alert show variant="warning">
                <b-icon variant="warning" icon="exclamation-diamond-fill" />
                Existem lançamentos que não são contemplados com os descontos do
                Reativa BH. Para emitir DRAM para débitos inscritos acesse
                <a
                  href="http://dividaativaonline.siatu.pbh.gov.br"
                  target="_blank"
                >
                  esse link </a
                >e para débitos não inscritos acesse
                <a
                  href="http://dividaativaonline.siatu.pbh.gov.br/DividaAtivaOnline/guiasSMAAR.xhtml"
                  target="_blank"
                  >esse link</a
                >
              </b-alert>
            </p>
          </div>

          <b-card class="mt-3" v-if="calculos.RESUMO_CALCULO">
            <div>
              <b-card class="bg-primary mx-5">
                <p class="text-white text-xl-center font-weight-bolder mb-5 h5">
                  Informações para pagamento à vista
                </p>
                <p
                  v-for="resumo in calculos.RESUMO_CALCULO"
                  :key="resumo"
                  class="text-white text-xl-left font-weight-bolder"
                >
                  {{ resumo }}
                </p>
              </b-card>

              <div class="d-flex justify-content-around mt-3">
                <b-button
                  class="mt-2"
                  variant="primary"
                  :disabled="bloqueioCancelamento"
                  @click.prevent="abrirDialogPagamentoAVista()"
                >
                  Pagar à vista
                </b-button>

                <b-button
                  class="mt-2"
                  variant="secondary"
                  :disabled="bloqueioCancelamento"
                  @click.prevent="abrirDialogParcelamento()"
                >
                  Parcelar
                </b-button>

                <b-button
                  class="mt-2"
                  variant="secondary"
                  @click.stop="simularPagamento"
                >
                  Simulação
                </b-button>
              </div>
            </div>
          </b-card>
          <b-modal
            ref="modal-lancamentos"
            title="Lançamentos"
            hide-footer
            scrollable
            @hide="limparInformacoesTabela"
            size="xl"
          >
            <div v-if="permitirCancelar" class="mb-3">
              <b-alert show variant="primary">
                <b-icon variant="primary" icon="info-circle-fill" />
                Existe parcelamento em andamento. Para emissão do DRAM no
                Programa Reativa BH acione o botão 'Cancelar Parcelamento'.
              </b-alert>
            </div>

            <tabela
              :items="lancamentos"
              :fields="cabecalhoLancamento"
              :selecionados="lancamentosSelecionados"
              title="lancamentos"
              v-on:mostrarSelecionados="getSelecionados($event)"
            />

            <b-row class="mt-3 float-right">
              <b-button
                class="mr-3"
                variant="secondary"
                :disabled="lancamentosSelecionados.length <= 0"
                @click="simularPagamento"
              >
                Simulação
              </b-button>

              <b-button
                variant="primary"
                class="mr-3"
                v-if="permitirCancelar"
                @click.prevent="abrirModal('modal-cancelamento')"
              >
                Cancelar parcelamento
              </b-button>

              <b-button
                class="mr-3"
                variant="primary"
                v-if="!permitirCancelar"
                :disabled="lancamentosSelecionados.length <= 0"
                @click="retornaCalculos"
              >
                Confirmar Seleção
              </b-button>
            </b-row>
          </b-modal>

          <b-modal
            ref="modal-pagamento-a-vista"
            hide-footer
            title="Pagar à Vista"
            size="xl"
            modal-class="small-modal"
          >
            <div
              v-if="calculos.OPCOES_PARCTO_DEMAIS.length > 0 || calculos.GUIA_VISTA_CESSAO"
            >
              <p>
                Para pagamento à vista deverão ser emitidos dois DRAM, uma para
                cada opção abaixo:
              </p>
              <b-row class="text-center" align-v="center">
                <b-col v-if="calculos.GUIA_VISTA_CESSAO">
                  <b-button
                    variant="primary"
                    @click="guiaPagamentoAVista('cessao')"
                  >
                    DRAM Lançamentos Cedidos
                  </b-button>
                </b-col>

                <b-col v-if="calculos.GUIA_VISTA_DEMAIS">
                  <b-button
                    variant="primary"
                    @click="guiaPagamentoAVista('demais')"
                  >
                    DRAM Demais Lançamentos
                  </b-button>
                </b-col>
              </b-row>
            </div>

            <div v-else>
              <b-alert show variant="danger">
                <b-icon variant="danger" icon="x-circle-fill" />
                Erro ao gerar os DRAMs para pagamento à vísta, favor verificar
                com o Administrator do sistema.</b-alert
              >
            </div>
          </b-modal>

          <b-modal
            ref="modal-confirmar-parcelamento"
            hide-footer
            title="Seleção de Parcelamentos"
            size="xl"
            modal-class="small-modal"
          >
            <div
              v-if="
                calculos.OPCOES_PARCTO_CESSAO || calculos.OPCOES_PARCTO_DEMAIS.length > 0
              "
            >
              <p>
                Para o parcelamento deverão ser emitidas dois DRAM, uma para
                cada opção abaixo:
              </p>
              <b-row class="text-center" align-v="center">
                <b-col v-if="calculos.OPCOES_PARCTO_CESSAO">
                  <b-button
                    variant="primary"
                    @click="abrirModalParcelamentoSeNecessario('cessao')"
                  >
                    DRAM de Lançamentos Cedidos
                  </b-button>
                </b-col>

                <b-col v-if="calculos.OPCOES_PARCTO_DEMAIS.length > 0">
                  <b-button
                    variant="primary"
                    @click="abrirModalParcelamentoSeNecessario('demais')"
                  >
                    DRAM Demais Lançamentos
                  </b-button>
                </b-col>
              </b-row>
            </div>

            <div v-else>
              <b-alert show variant="danger">
                <b-icon variant="danger" icon="x-circle-fill" />
                Erro ao gerar os DRAM para pagamento à vísta, favor verificar
                com o Administrator do sistema.</b-alert
              >
            </div>
          </b-modal>

          <b-modal
            ref="modal-parcelamento"
            hide-footer
            title="Parcelamento"
            size="xl"
            @hide="limparCamposParcelamento()"
          >
            <div
              :v-if="mensagemParcelamento"
              v-for="i in mensagemParcelamento"
              :key="i"
            >
              <p>
                <b-alert show variant="danger" dismissible>
                  <b-icon variant="danger" icon="x-circle-fill" />{{
                    i
                  }}</b-alert
                >
              </p>
            </div>
            <div
              v-if="
                calculos.OPCOES_PARCTO_CESSAO || calculos.OPCOES_PARCTO_DEMAIS.length > 0
              "
            >
              <p>Selecione abaixo uma das opções de parcelamento</p>
              <div
                class="mb-3"
                v-if="calculos.OPCOES_PARCTO_DEMAIS.length > 0 && mostrarDemais"
              >
                <h5>Demais Lançamentos</h5>
                <b-form-select
                  id="demaisLancamentos"
                  v-model="escolhaDemaisParcelamentos"
                  :options="listaDemaisParcelamentos"
                />
              </div>

              <div
                class="mb-3"
                v-if="calculos.OPCOES_PARCTO_CESSAO && mostrarCessao"
              >
                <h5>Lançamentos Cedidos</h5>
                <b-form-select
                  id="demaisLancamentos"
                  class="mb-2 mr-sm-2 mb-sm-0"
                  v-model="escolhaCessao"
                  :options="listaCessao"
                />
              </div>

              <h4 class="mt-5">Contato</h4>
              <b-row class="mb-3">
                <b-col sm="2" align-self="end">
                  <label for="telefoneCelular">Telefone Celular</label>
                </b-col>
                <b-col sm="3" align-self="start">
                  <b-form-input
                    id="telefoneCelular"
                    placeholder="(31)99999-9999"
                    v-mask="['(##)#####-####']"
                    v-model="informacaoParcelamento.telefone"
                  >
                  </b-form-input>
                </b-col>
              </b-row>

              <b-row class="mb-3">
                <b-col sm="2" align-self="end">
                  <label for="email">Email</label>
                </b-col>
                <b-col sm="3" align-self="start">
                  <b-form-input
                    type="email"
                    id="email"
                    placeholder="exemplo@exemplo.com.br"
                    v-model="informacaoParcelamento.email"
                  >
                  </b-form-input>
                </b-col>
              </b-row>

              <div class="float-right">
                <b-button
                  variant="primary"
                  :disabled="
                    (escolhaDemaisParcelamentos === '' &&
                      escolhaCessao === '') ||
                    (informacaoParcelamento.email.length < 6 &&
                      !informacaoParcelamento.email.includes('@') &&
                      informacaoParcelamento.telefone.length < 14)
                  "
                  @click.prevent="emitirGuiaParcelamento"
                >
                  Emitir DRAM</b-button
                >
              </div>
            </div>

            <div v-else>
              <b-alert show variant="danger"
                ><b-icon variant="danger" icon="x-circle-fill" />Erro ao gerar
                os parcelamentos, favor verificar com o Administrator do
                sistema.</b-alert
              >
            </div>
          </b-modal>

          <b-modal
            ref="modal-cancelamento"
            hide-footer
            title="Cancelar Parcelamento"
            size="xl"
            @show="confirmarCancelamento()"
            @hide="limparCamposCancelamento()"
          >
            <div
              :v-if="mensagemCancelamento"
              v-for="i in mensagemCancelamento"
              :key="i"
            >
              <p>
                <b-alert show variant="danger" dismissible>
                  <b-icon variant="danger" icon="x-circle-fill" />
                  {{ i }}
                </b-alert>
              </p>
            </div>
            <div
              :v-if="mensagemCancelamentoSucesso"
              v-for="i in mensagemCancelamentoSucesso"
              :key="i"
            >
              <p>
                <b-alert show variant="success" dismissible>
                  <b-icon variant="success" icon="check2" />
                  {{ i }}
                </b-alert>
              </p>
            </div>

            <h3>Relação de parcelamentos ativos</h3>

            <div v-if="informacoesCancelamento.listaParcelamento">
              <b-table
                :items="informacoesCancelamento.listaParcelamento"
                :fields="cabecalhoCancelamento"
              >
              </b-table>
            </div>

            <h5>
              Preencha os dados abaixo para confirmar o cancelamento do
              parcelamento
            </h5>

            <b-row class="my-3">
              <b-col sm="2" align-self="end">
                <label for="cadastroNacional">CPF/CNPJ do Solicitante</label
                ><span class="ml-1" style="color: red">*</span>
              </b-col>
              <b-col sm="3" align-self="start">
                <b-form-input
                  id="cadastroNacional"
                  v-mask="['###.###.###-##', '##.###.###/####-##']"
                  @keydown="validacaoCPFCNPJ()"
                  v-model="informacoesCancelamento.cpfCnpj"
                >
                </b-form-input>
              </b-col>
            </b-row>

            <b-row class="mb-3">
              <b-col sm="2" align-self="end">
                <label for="razaoSocial">Nome/Razão Social</label>
              </b-col>
              <b-col sm="3" align-self="start">
                <b-form-input
                  id="razaoSocial"
                  disabled="disabled"
                  v-model="informacoesCancelamento.razaoSocial"
                >
                </b-form-input>
              </b-col>
            </b-row>

            <h5>Contato</h5>
            <b-row class="mb-3">
              <b-col sm="2" align-self="end">
                <label for="telefone">Telefone Celular</label>
              </b-col>
              <b-col sm="3" align-self="start">
                <b-form-input
                  id="telefone"
                  v-mask="['(##)####-####', '(##)#####-####']"
                  placeholder="(31)99999-9999"
                  v-model="informacoesCancelamento.telefoneCelular"
                >
                </b-form-input>
              </b-col>
            </b-row>

            <b-row class="mb-3">
              <b-col sm="2" align-self="end">
                <label for="email">Email</label>
              </b-col>
              <b-col sm="3" align-self="start">
                <b-form-input
                  id="email"
                  type="email"
                  v-model="informacoesCancelamento.email"
                  placeholder="exemplo@exemplo.com.br"
                >
                </b-form-input>
              </b-col>
            </b-row>

            <b-card
              v-if="
                informacoesCancelamento.telefoneEnviado ||
                informacoesCancelamento.emailEnviado
              "
              class="bg-secondary mt-5 mb-3 w-50 mx-auto"
            >
              <div style="text-align: center">
                <span class="font-weight-bolder text-white">
                  Preencha o código recebido para confirmar o cancelamento
                </span>
                <b-form-input
                  id="cancelarParcelamento"
                  v-model="informacoesCancelamento.codigoCancelamento"
                />
              </div>
            </b-card>

            <div
              v-if="
                informacoesCancelamento.email &&
                informacoesCancelamento.emailEnviado
              "
            >
              <b-alert show variant="warning">
                <b-icon variant="warning" icon="exclamation-diamond-fill" />
                Foi enviada uma mensagem para o e-mail
                {{ informacoesCancelamento.email }} com um código de
                confirmação. É obrigatório o preenchimento para dar continuidade
                no cancelamento do parcelamento. Favor verificar se a mensagem
                foi recebida!</b-alert
              >
            </div>

            <div
              v-if="
                informacoesCancelamento.telefoneCelular &&
                informacoesCancelamento.telefoneEnviado
              "
            >
              <b-alert show variant="warning">
                <b-icon variant="warning" icon="exclamation-diamond-fill" />
                Foi enviada uma mensagem para o número
                {{ informacoesCancelamento.telefoneCelular }} com um código de
                confirmação. É obrigatório o preenchimento para dar continuidade
                no cancelamento do parcelamento. Favor verificar se a mensagem
                foi recebida!
              </b-alert>
            </div>

            <b-row v-if="!mostrarConfirmacaoCancelamento" class="float-right">
              <b-button
                variant="primary"
                class="mr-3"
                @click="enviarMensagemCancelamentoParcelamento()"
                :disabled="
                  informacoesCancelamento.cpfCnpj.length < 11 ||
                  informacoesCancelamento.telefoneCelular.length < 14
                "
              >
                Enviar SMS
              </b-button>

              <b-button
                variant="primary"
                class="mr-3"
                @click="enviarEmailCancelamentoParcelamento()"
                :disabled="
                  informacoesCancelamento.cpfCnpj.length < 11 ||
                  (informacoesCancelamento.email.length < 6 &&
                    !informacoesCancelamento.email.includes('@'))
                "
              >
                Enviar E-mail
              </b-button>
            </b-row>

            <b-row v-else class="float-right">
              <b-button
                variant="secondary"
                class="mr-3"
                @click="enviarMensagemCancelamentoParcelamento()"
                :disabled="informacoesCancelamento.telefoneCelular.length < 14"
              >
                Reenviar SMS
              </b-button>

              <b-button
                variant="secondary"
                class="mr-3"
                @click="enviarEmailCancelamentoParcelamento()"
                :disabled="
                  informacoesCancelamento.email.length < 6 &&
                  !informacoesCancelamento.email.includes('@')
                "
                >Reenviar E-mail</b-button
              >

              <b-button
                variant="primary"
                class="mr-3"
                @click="finalizarCancelamento()"
                :disabled="
                  informacoesCancelamento.codigoCancelamento.length <= 5
                "
              >
                Confirmar cancelamento
              </b-button>
            </b-row>
          </b-modal>

          <b-modal
            ref="dialog-confirmar-parcelamento"
            hide-footer
            title="Confirmação de parcelamento"
            size="xs"
            modal-class="small-modal"
            centered
          >
            <p>
              Não foram selecionados todos os débitos do tipo "{{
                orgaoCobranca.DESCRICAO
              }}" para esta emissão. Você deseja prosseguir com esta seleção?
            </p>

            <b-button-group class="w-100">
              <b-button
                colspan="6"
                variant="outline-secondary "
                @click="fecharModal('dialog-confirmar-parcelamento')"
                >Não</b-button
              >
              <b-button
                colspan="6"
                class="ml-3"
                variant="primary"
                @click="mostrarModalParcelamento()"
                >Sim</b-button
              >
            </b-button-group>
          </b-modal>

          <b-modal
            ref="dialog-confirmar-a-vista"
            hide-footer
            title="Confirmação de pagamento à vista"
            size="sm"
            modal-class="small-modal"
            centered
          >
            <p>
              Não foram selecionados todos os débitos do tipo "{{
                orgaoCobranca.DESCRICAO
              }}" para esta emissão. Você deseja prosseguir com esta seleção?
            </p>

            <b-button-group class="w-100">
              <b-button
                colspan="6"
                variant="outline-secondary "
                @click="fecharModal('dialog-confirmar-a-vista')"
                >Não</b-button
              >
              <b-button
                colspan="6"
                class="ml-3"
                variant="primary"
                @click="
                  abrirModalPagamentoAVistaSeNecessario(
                    'modal-pagamento-a-vista'
                  )
                "
                >Sim</b-button
              >
            </b-button-group>
          </b-modal>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { mask } from "vue-the-mask";
import loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import validarCNPJ from "../../validations";
import validarCPF from "../../validations";
import constantes from "../../constants/index";
// import formatador from "../utils/formatarCampos";
import Tabela from "../../components/tabela.vue";

export default {
  components: {
    loading,
    Tabela,
  },
  directives: {
    mask,
  },
  data() {
    return {
      carregando: false,

      usuarioAutenticado: this.$store.getters.isAuthenticated,
      mascaraIdentificador: {},
      userName: this.$store.getters.userInfo.preferred_username,
      origemAcesso: this.$store.getters.userInfo.origem,

      tokens: {
        L: {
          pattern: /[A-Za-z ]/,
          transform: function (v) {
            return v.toLocaleUpperCase();
          },
        },
        J: {
          pattern: /[0-9xX]/,
          transform: function (v) {
            return v.toLocaleUpperCase();
          },
        },
        E: {
          pattern: /[A-Za-z0-9 ]/,
          transform: function (v) {
            if (v.match(/\d/)) return " " + v;
            else return v.toLocaleUpperCase();
          },
        },
        X: {
          pattern: /[A-Za-z0-9]/,
          transform: function (v) {
            return v.toLocaleUpperCase();
          },
        },
        "#": { pattern: /\d/ },
      },

      corMensagem: "danger",
      iconMensErro: "",

      mensagemSucesso: [],
      mensagemErro: [],
      mostrarSelecaoLancamentos: false,
      mensagemLancamentos: [],
      informativoSelecao: false,
      mensagemParcelamento: [],
      mensagemCancelamento: [],
      mensagemCancelamentoSucesso: [],

      mensagemValidacaoCPFCNPJ: "",
      erroValidacaoCPFCNPJ: "",

      mensagemValidacaoIdentificador: "",
      erroValidacaoIdentificador: "",

      mensagemValidacaoParcelamento: "",
      erroValidacaoParcelamento: "",

      desabilitacodigoNacional: false,
      desabilitaIdentificador: false,
      desabilitaParcelamento: false,

      placeHolderIdentificador: "",
      opcoesIdentificador: [],

      dadosContribuinte: {
        cadastroNacional: "",
        cpf: "",
        nomeContribuinte: "",
        cnpj: "",
        tipoIdentificador: "",
        identificador: "",
        numeroParcelamento: "",
        placaVeiculo: "",
        codigoLancamento: "",
        processoJudicial: "",
        transacao: "",
      },
      mostrarDemaisInformacoes: false,
      mostrarErroMuitosLancamentos: false,
      informacaoContribuinte: {
        cadastroNacional: "",
        nome: "",
        idPessoa: "",
        idPessoaPapel: "",
        nroParcelamento: "",
        placaVeiculo: "",
        processoJudicial: "",
        transacao: "",
      },
      cnpjsRelacionados: [],
      cnpjSelecionado: "",      

      preencheCpfCnpjOK: false,
      preencheIdentificadorOK: false,

      lancamentosSelecionados: [],
      demaisParcelamento: [],
      parcelamentoCessao: [],
      bloquearExibirLancamentos: false,

      selecionarTodosLancamentos: false,
      cabecalhoLancamento: [
        { nomeExterno: "", nomeInterno: "selected" },
        {
          nomeExterno: "Descrição Débito",
          nomeInterno: "DSC_ORGAO_COBRANCA",
        },
        { nomeExterno: "Identificador", nomeInterno: "IDENTIFICADOR" },
        {
          nomeExterno: "Lançamento",
          nomeInterno: "CODIGO_LANCAMENTO",
        },
        {
          nomeExterno: "Situação",
          nomeInterno: "ESTADO_LANCAMENTO",
        },
        {
          nomeExterno: "Valor Corrigido",
          nomeInterno: "VALOR_CORRIGIDO",
          formatter: this.formatCurrency,
        },
        {
          nomeExterno: "Valor Multa",
          nomeInterno: "VALOR_MULTA",
          formatter: this.formatCurrency,
          sortable: true,
        },
        {
          nomeExterno: "Valor Juros",
          nomeInterno: "VALOR_JUROS",
          formatter: this.formatCurrency,
          sortable: true,
        },
        {
          nomeExterno: "Valor Selic",
          nomeInterno: "VALOR_SELIC",
          formatter: this.formatCurrency,
          sortable: true,
        },
        {
          nomeExterno: "Valor Honorário",
          nomeInterno: "VALOR_HONORARIO",
          formatter: this.formatCurrency,
          sortable: true,
        },
        {
          nomeExterno: "Valor Desconto",
          nomeInterno: "DESCONTOS", // Criado pelo template do tabela
          formatter: this.formatCurrency,
        },
        {
          nomeExterno: "Valor à Vista ",
          nomeInterno: "PAGAMENTO_VISTA", // Criado pelo template do tabela
          formatter: this.formatCurrency,
        },
        {
          nomeExterno: "Número Parcelamento",
          nomeInterno: "NUMERO_PARCELAMENTO",
          sortable: true,
        },
      ],

      listaDemaisParcelamentos: [],
      escolhaDemaisParcelamentos: "",

      listaCessao: [],
      escolhaCessao: "",

      cabecalhoCancelamento: [
        {
          nomeExterno: "Número do Parcelamento",
          nomeInterno: "NROPARCELAMENTO",
        },
        {
          nomeExterno: "Quantidade de Parcelas",
          nomeInterno: "QTDPARCELAS",
        },
        {
          nomeExterno: "Quantidade de Parcelas em Aberto",
          nomeInterno: "QTDPARCELASABERTAS",
        },
        {
          nomeExterno: "Saldo Atualizado",
          nomeInterno: "VALORATUALIZADO",
          formatter: this.formatCurrency,
        },
        {
          nomeExterno: "Valor à vista com desconto",
          nomeInterno: "VALORDESCONTO",
          formatter: this.formatCurrency,
        },
      ],

      opcoesOrgaosCobranca: [],
      orgaoCobranca: {},
      listaAgrupamentos: [],
      lancamentos: [],
      carregandoTabelaLancamentos: false,

      calculos: {
        OPCOES_PARCTO_CESSAO: [],
        OPCOES_PARCTO_DEMAIS: [],
        LANCAMENTO_CESSAO: [],
        LANCAMENTO_DEMAIS: [],
      },

      msg: "",

      mostrarCessao: false,
      mostrarDemais: false,

      permitirCancelar: false,
      bloqueioCancelamento: false,
      lancamentosCancelamento: [],

      proibidos: [
        "09661758000145",
        "09648037000103",
        "21388632000144",
        "09674784000108",
        "09647973000191",
        "02939448000109",
        "17155730000164",
        "71395362000177",
        "16667693000100",
        "17211202000185",
        "19160696000141",
        "01823576000200",
        "03190167000150",
        "22750673000100",
        "00489828001399",
        "00102865604",
      ],

      informacoesCancelamento: {
        cpfCnpj: "",
        razaoSocial: "",
        telefoneCelular: "",
        email: "",
        codigoCancelamento: "",
        confirmacao: "",
        emailEnviado: false,
        telefoneEnviado: false,
        listaParcelamento: [],
        dadosExibicao: [],
      },

      tokenCancelamento: "",
      mostrarConfirmacaoCancelamento: false,

      informacaoParcelamento: {
        telefone: "",
        email: "",
      },
    };
  },
  methods: {
    focusInput: function (campo) {
      document.getElementById(campo).focus();
    },

//
    scrollToTop: function () {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    },
    handleScroll: function () {
      this.showButton = window.scrollY > 100;
    },
//
    pesquisar: async function () {
      let auxIdentificador = this.dadosContribuinte.identificador;
      let auxTipoIdentificador = this.dadosContribuinte.tipoIdentificador;

      this.calculos = {
        OPCOES_PARCTO_CESSAO: [],
        OPCOES_PARCTO_DEMAIS: [],
        LANCAMENTO_CESSAO: [],
        LANCAMENTO_DEMAIS: [],
      };

      this.orgaoCobranca = {};
      this.carregando = true;

      this.mensagemSucesso = [];
      this.mostrarErroMuitosLancamentos = false;
      this.bloquearExibirLancamentos = false;

      this.limparMensagensDeErro();

      // PLACA DE VEICULO)
      if (this.dadosContribuinte.tipoIdentificador === 10) {
        this.dadosContribuinte.placaVeiculo =
          this.dadosContribuinte.identificador;
      }

      // PARCELAMENTO    
      if (this.dadosContribuinte.tipoIdentificador === 14) {
        this.dadosContribuinte.numeroParcelamento =
          this.dadosContribuinte.identificador;
      }

      // PROCESSO JUDICIAL
      if (this.dadosContribuinte.tipoIdentificador === 15) {
        this.dadosContribuinte.processoJudicial =
          this.dadosContribuinte.identificador;
      }

      // TRANSACAO
      if (this.dadosContribuinte.tipoIdentificador === 16) {
        this.dadosContribuinte.identificador =
          this.dadosContribuinte.identificador.slice(0, 12);
        this.dadosContribuinte.transacao = this.dadosContribuinte.identificador;
      }

      await axios
        .post(this.$env.url_backend + constantes.buscarContribuinte, {
          dadosContribuinte: this.dadosContribuinte,
        })
        .then((response) => {
          const retorno = response.data;
          this.dadosContribuinte.identificador = auxIdentificador;
          this.dadosContribuinte.tipoIdentificador = auxTipoIdentificador;
          const infoContribuinteRetorno = retorno[0];

          if (infoContribuinteRetorno.MENSAGEM_RETORNO === "OK") {
            this.mensagemErro = [];
            this.mostrarDemaisInformacoes = true;

            this.informacaoContribuinte.nome = infoContribuinteRetorno.NOME;
            this.dadosContribuinte.nomeContribuinte =
              infoContribuinteRetorno.NOME;
            this.informacaoContribuinte.cadastroNacional =
              infoContribuinteRetorno.CODIGO_NACIONAL;
            this.informacaoContribuinte.idPessoa =
              infoContribuinteRetorno.ID_PESSOA;
            this.informacaoContribuinte.idPessoaPapel =
              infoContribuinteRetorno.ID_PESSOA_PAPEL;
            this.informacaoContribuinte.idParcelamento =
              infoContribuinteRetorno.ID_PARCELAMENTO;
            this.informacaoContribuinte.nroParcelamento =
              this.dadosContribuinte.numeroParcelamento;
            if (this.dadosContribuinte.placaVeiculo === "") {
              this.informacaoContribuinte.placaVeiculo = null;
            } else {
              this.informacaoContribuinte.placaVeiculo =
                this.dadosContribuinte.placaVeiculo.replace(/[^\d| |\w]+/g, "");
            }
            if (this.dadosContribuinte.processoJudicial === "") {
              this.informacaoContribuinte.processoJudicial = null;
            } else {
              this.informacaoContribuinte.processoJudicial =
                this.dadosContribuinte.processoJudicial.replace(
                  /[^\d| |\w]+/g,
                  ""
                );
            }
            if (this.dadosContribuinte.transacao === "") {
              this.informacaoContribuinte.transacao = null;
            } else {
              this.informacaoContribuinte.transacao =
                this.dadosContribuinte.transacao;
            }

            let cpfCnpj = "";

            if (this.dadosContribuinte.cadastroNacional != "")
              cpfCnpj = this.dadosContribuinte.cadastroNacional.replace(
                /[^\d]+/g,
                ""
              );

            let existeCnpjProibido = false;
            if (cpfCnpj) existeCnpjProibido = this.proibidos.includes(cpfCnpj);
            if (!existeCnpjProibido) {             
              this.lancamentosAgrupados();
            } else {
              this.carregando = false;
              this.mostrarErroMuitosLancamentos = true;
            }
            // }
          } else {
            this.dadosContribuinte.identificador =
              this.dadosContribuinte.identificador.replace(/[^\d]+/g, "");
            this.dadosContribuinte.identificador = "";
            this.calculos = {
              OPCOES_PARCTO_CESSAO: [],
              OPCOES_PARCTO_DEMAIS: [],
              LANCAMENTO_CESSAO: [],
              LANCAMENTO_DEMAIS: [],
            };

            this.informacaoContribuinte = {};

            this.mostrarDemaisInformacoes = false;
            this.mostrarSelecaoLancamentos = false;
            this.mostrarSelecaoDebitos = false;
            this.mostrarErroMuitosLancamentos = false;

            this.orgaoCobranca = [];
            this.carregando = true;
            this.limparCampos();
          
            this.corMensagem = "danger";
            this.iconMensErro = "x-circle-fill";
            this.carregaListaMensagensErros(infoContribuinteRetorno.MENSAGEM_RETORNO);  
            this.carregando = false;
          }
        })
        .catch(() => {
          this.carregando = false;
          this.limparCampos();
          this.corMensagem = "danger";
          this.iconMensErro = "x-circle-fill";
          this.carregaListaMensagensErros("PÁGINA EM MANUTENÇÃO, FAVOR ACESSAR MAIS TARDE");
          window.scrollTo(0, 0);
        });
      if (this.dadosContribuinte.identificador != "") {
        this.dadosContribuinte.identificador =
          this.dadosContribuinte.identificador.replace(/[^\d]+/g, "");
        this.dadosContribuinte.identificador = auxIdentificador;
      }
    },

    montaSelecionado: function (codigoNacional, razaoSocial) {
      this.dadosContribuinte.cadastroNacional = codigoNacional;
      this.dadosContribuinte.nomeContribuinte = razaoSocial;
    },   

   formataCPF: function (valor) {
     return valor.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/g, "$1.$2.$3-$4");
   },

   formataCNPJ: function (valor) {
      return valor.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/g, "$1.$2.$3/$4-$5");
    },

    verificaLinkMens: function (valor) {
      let mensagem = {
        mensInicio: "",
        mensLink: "",
        mensFim: "",
      };
      if (valor.indexOf("www") >= 0 || valor.indexOf("http") >= 0) {
        let posicaoInicialPreLink = 0;
        posicaoInicialPreLink = valor.indexOf("www"); // procura por www
        if (posicaoInicialPreLink < 0) {
          // não encontrou
          posicaoInicialPreLink = valor.indexOf("http"); // procura por http
        }
        if (posicaoInicialPreLink >= 0) {
          let valorStr = valor.substring(posicaoInicialPreLink); // retorna o substring a partir da posicaoInicialPreLink
          if (valorStr != "") {
            let palavras = valorStr.split(" "); // divide o valorStr em palavras
            mensagem.mensLink = palavras[0];
          }
        } else {
          posicaoInicialPreLink = valor.length;
        }
        mensagem.mensInicio = valor.substring(0, posicaoInicialPreLink);
        //  return aValorPreLink;
        mensagem.mensFim = valor.substring(
          posicaoInicialPreLink + mensagem.mensLink.length
        );
      } else {
        mensagem.mensInicio = valor;
      }
      return mensagem;
    },

    lancamentosAgrupados: async function () {
      this.carregandoTabelaLancamentos = true;
      this.listaDemaisParcelamentos = [];
      this.listaCessao = [];
      this.informativoSelecao = false;
      this.mensagemErro = [];

      await axios
        .post(this.$env.url_backend + constantes.agrupaLancamentos, {
          informacaoContribuinte: this.informacaoContribuinte,
        })
        .then((response) => {
          const retorno = response.data;

          const listaLancamentos = retorno[0];

          if (
            listaLancamentos.LISTA_AGRUPAMENTO == null ||
            listaLancamentos.LISTA_AGRUPAMENTO.length == 0 ||
            listaLancamentos.MENSAGEM_RETORNO != "OK"
          ) {
            this.corMensagem = "danger";
            this.iconMensErro = "x-circle-fill";
            this.carregaListaMensagensErros(listaLancamentos.MENSAGEM_RETORNO);  
            this.listaAgrupamentos = [];
          }
          if (listaLancamentos.MENSAGEM_RETORNO === "OK") {
            this.mostrarSelecaoLancamentos = true;
            this.listaAgrupamentos = [];

            const lancamentos = [];

            listaLancamentos.LISTA_AGRUPAMENTO.map((lancamento) =>
              lancamentos.push(lancamento)
            );

            this.listaAgrupamentos = lancamentos;
            if (
              listaLancamentos.MENSAGEM_SELECAO &&
              listaLancamentos.MENSAGEM_SELECAO.includes(
                "Para emitir DRAM para débitos inscritos acesse esse link e para débitos não inscritos acesse esse link"
              )
            ) {
              this.informativoSelecao = true;
            } else if (listaLancamentos.MENSAGEM_SELECAO !== " ") {
              this.corMensagem = "warning";
              this.iconMensErro = "exclamation-lg";
              this.carregaListaMensagensErros(listaLancamentos.MENSAGEM_SELECAO); 
            }
          } else {
            if (listaLancamentos.MENSAGEM_RETORNO !== " ") {
              this.corMensagem = "danger";
              this.iconMensErro = "x-circle-fill";
              this.carregaListaMensagensErros(listaLancamentos.MENSAGEM_RETORNO);
            }
            if (
              listaLancamentos.MENSAGEM_SELECAO !== " " &&
              listaLancamentos.MENSAGEM_SELECAO &&
              !listaLancamentos.MENSAGEM_SELECAO.includes(
                "Existem lançamentos que não são contemplados com os descontos do Reativa BH. Para emitir DRAM para débitos inscritos acesse esse link e para débitos não inscritos acesse esse link"
              )
            ) {
              this.corMensagem = "warning";
              this.iconMensErro = "exclamation-lg";
              this.carregaListaMensagensErros(listaLancamentos.MENSAGEM_SELECAO);
            }
            if (
              listaLancamentos.MENSAGEM_SELECAO &&
              listaLancamentos.MENSAGEM_SELECAO &&
              listaLancamentos.MENSAGEM_SELECAO.includes(
                "Existem lançamentos que não são contemplados com os descontos do Reativa BH. Para emitir DRAM para débitos inscritos acesse esse link e para débitos não inscritos acesse esse link"
              )
            ) {
              this.informativoSelecao = true;
            }

            this.mostrarSelecaoLancamentos = false;
          }

          this.carregando = false;
          this.carregandoTabelaLancamentos = false;
        })
        .catch((err) => {
          this.carregando = false;
          this.carregandoTabelaLancamentos = false;
          this.corMensagem = "danger";
          this.iconMensErro = "x-circle-fill";
          this.carregaListaMensagensErros(err);
          window.scrollTo(0, 0);
        });
    },
 
    carregaListaMensagensErros: function(msg) {
        // verifica se na mensagem tem algum link
        // se existir, isola o link na variavel "mensLink"  
        let mens = this.verificaLinkMens(msg);              
        this.mensagemErro.push(mens);
        // Basicamente o que ele faz é iterar sobre os objetos do array 
        // e adicionar o seu valor serializado ao objeto temporário criado 
        // no 2º argumento como uma chave, e assim indicar se ele já foi adicionado
        // colocando-o o valor true. Assim, quando chega um valor duplicado, 
        // a condicional !this[JSON.stringify(a)] da false, não adicionando-o ao filtro.
        this.mensagemErro = this.mensagemErro.filter(function (a) {
                return !this[JSON.stringify(a)] && (this[JSON.stringify(a)] = true);
              }, Object.create(null));  
        // volta para o topo da pagina
        setTimeout(function() {window.scrollTo({ top: 0, behavior: 'smooth' });}, 100);                 
    }, 

    retornaCalculos: async function () {

      this.carregando = true;
      this.listaDemaisParcelamentos = [];
      this.listaCessao = [];

      this.mensagemErro = [];

      const lancamentos = this.lancamentosSelecionados.map(
        (lancamento) => lancamento.ID_LANCAMENTO
      );
      const dtCalculo = new Date();
      const dtVencto = null;
      const idProcesso = null;

      await axios
        .post(this.$env.url_backend + constantes.retornaCalculos, {
          lancamentosSelecionados: lancamentos,
          dtCalculo: dtCalculo,
          dtVencto: dtVencto,
          idProcesso: idProcesso,
          usuario: this.origemAcesso,
        })
        .then((response) => {
          const retorno = response.data;
          const calculosRetornados = retorno[0];
          this.calculos = calculosRetornados;

          if (this.calculos.OPCOES_PARCTO_DEMAIS.length > 0) {
            this.calculos.OPCOES_PARCTO_DEMAIS.map((calculo) => {
              this.listaDemaisParcelamentos.push({
                text: `Entrada de ${this.formatCurrency(
                  calculo.AVLRDEPOSITOINICIAL
                )} + ${calculo.AQTDPARCELA} parcela(s) de ${this.formatCurrency(
                  calculo.AVLRPARCELA
                )} (Desconto de ${calculo.APERCDEPOSITOINICIAL}%)`,
                value: calculo,
                disabled: false,
                hidden: false,
              });
            });

            this.listaDemaisParcelamentos.unshift({
              text: "Clique aqui para selecionar uma opção de parcelamento",
              value: "",
              selected: true,
              disabled: true,
              hidden: true,
            });

            this.calculos.LANCAMENTO_DEMAIS =
              calculosRetornados.LANCAMENTO_DEMAIS;
          }

          if (this.calculos.OPCOES_PARCTO_CESSAO) {
            this.calculos.OPCOES_PARCTO_CESSAO.map((calculo) => {
              this.listaCessao.push({
                text: `Entrada de ${this.formatCurrency(
                  calculo.AVLRDEPOSITOINICIAL
                )} + ${calculo.AQTDPARCELA} parcela(s) de ${this.formatCurrency(
                  calculo.AVLRPARCELA
                )} (Desconto de ${calculo.APERCDEPOSITOINICIAL}%)`,
                value: calculo,
                disabled: false,
                hidden: false,
              });
            });

            this.listaCessao.unshift({
              text: "Clique aqui para selecionar uma opção de parcelamento",
              value: "",
              selected: true,
              disabled: true,
              hidden: true,
            });

            this.calculos.LANCAMENTO_CESSAO =
              calculosRetornados.LANCAMENTO_CESSAO;
          }
        })
        .catch(() => {
          this.carregando = false          
          this.fecharModal("modal-lancamentos");
          this.corMensagem = "danger";
          this.iconMensErro = "x-circle-fill";
          this.carregaListaMensagensErros("PÁGINA EM MANUTENÇÃO, FAVOR ACESSAR MAIS TARDE.");
        });
      this.fecharModal("modal-lancamentos"); 
      await axios
        .post(this.$env.url_backend + constantes.agrupaLancamentos, {
          informacaoContribuinte: this.informacaoContribuinte,
        })
        .then((response) => {
          const retorno = response.data;

          const listaLancamentos = retorno[0];

          this.listaLancamentos = listaLancamentos;
        })
        .catch(() => {
          this.carregando = false;
          this.corMensagem = "danger";
          this.iconMensErro = "x-circle-fill";
          this.carregaListaMensagensErros("PÁGINA EM MANUTENÇÃO, FAVOR ACESSAR MAIS TARDE.");         
        });

      this.carregando = false;
    },

    enviarMensagemCancelamentoParcelamento: async function () {
      this.mensagemCancelamentoSucesso = [];
      this.mensagemCancelamento = [];
      const telefone = this.informacoesCancelamento.telefoneCelular;
      const codigoCancelamento = this.informacoesCancelamento.confirmacao;

      const informacaoCancelamento = { telefone, codigoCancelamento };

      await axios
        .post(
          this.$env.url_backend +
            constantes.enviarMensagemCancelamentoParcelamento,
          {
            informacaoCancelamento,
          }
        )
        .then(() => {
          this.mensagemCancelamentoSucesso.push("SMS enviado com sucesso!");
          this.mostrarConfirmacaoCancelamento = true;
          this.informacoesCancelamento.telefoneEnviado = true;
        })
        .catch(() => {
          this.corMensagem = "danger";
          this.iconMensErro = "x-circle-fill";
          this.carregaListaMensagensErros("PÁGINA EM MANUTENÇÃO, FAVOR ACESSAR MAIS TARDE.");
          this.carregando = false;
          this.informacoesCancelamento.telefoneEnviado = false;
        });
    },
    enviarEmailCancelamentoParcelamento: async function () {
      this.mensagemCancelamento = [];
      this.mensagemCancelamentoSucesso = [];
      const email = this.informacoesCancelamento.email;
      const codigoCancelamento = this.informacoesCancelamento.confirmacao;

      const informacaoCancelamento = { email, codigoCancelamento };

      await axios
        .post(
          this.$env.url_backend +
            constantes.enviarEmailCancelamentoParcelamento,
          {
            informacaoCancelamento,
          }
        )
        .then(() => {
          this.mensagemCancelamentoSucesso.push("E-mail enviado com sucesso!");
          this.mostrarConfirmacaoCancelamento = true;
          this.informacoesCancelamento.emailEnviado = true;
        })
        .catch(() => {
          this.corMensagem = "danger";
          this.iconMensErro = "x-circle-fill";
          this.carregaListaMensagensErros("PÁGINA EM MANUTENÇÃO, FAVOR ACESSAR MAIS TARDE.");
          this.carregando = false;
          this.informacoesCancelamento.emailEnviado = false;
        });
    },

    emitirGuiaParcelamento: async function () {
      this.mensagemParcelamento = [];

      const email = this.informacaoParcelamento.email;
      const telefone = this.informacaoParcelamento.telefone;
      const usuario = this.origemAcesso;
      const selecaoEscolhaDemaisParcelamentos = this.escolhaDemaisParcelamentos;
      const selecaoEscolhaCessao = this.escolhaCessao;

      if (selecaoEscolhaCessao) {       
        const lancamentos = this.calculos.LANCAMENTO_CESSAO;

        const informacaoGuia = {
          lancamentos,
          email,
          telefone,
          usuario,
          operadorSistema: this.userName,
          selecao: selecaoEscolhaCessao,     
        };

        this.guiaParcelamento(informacaoGuia);
      }

      if (selecaoEscolhaDemaisParcelamentos) {
        const lancamentos = this.calculos.LANCAMENTO_DEMAIS;

        const informacaoGuia = {
          lancamentos,
          email,
          telefone,
          usuario,
          operadorSistema: this.userName,
          selecao: selecaoEscolhaDemaisParcelamentos,
        };

        this.guiaParcelamento(informacaoGuia);
      }
    },

    limparCamposCancelamento: function () {
      this.informacoesCancelamento.listaParcelamento = [];

      this.informacoesCancelamento.cpfCnpj = "";
      this.informacoesCancelamento.razaoSocial = "";
      this.informacoesCancelamento.telefoneCelular = "";
      this.informacoesCancelamento.telefoneEnviado = false;
      this.informacoesCancelamento.email = "";
      this.informacoesCancelamento.emailEnviado = false;
      this.mensagemLancamentos = [];
      this.informativoSelecao = false;
      this.mostrarConfirmacaoCancelamento = false;
      this.informacoesCancelamento.codigoCancelamento = "";

      this.mensagemCancelamento = [];
      this.mensagemCancelamentoSucesso = [];
    },


    buscarCNPJSRelacionados: async function () {
      this.carregando = true;
      await axios
        .get(
          `${this.$env.url_backend}${constantes.buscarCNPJRelacionados}?cpf=${this.$store.getters.userInfo.preferred_username}`
        )
        .then((response) => {
          this.cnpjsRelacionados =
            response.data.cnpjRelacionados.listaEstabelecimento.map(
              (estabelecimento) => {
                return {
                  text: `CNPJ: ${this.formataCNPJ(
                    estabelecimento.cnpj
                  )} - ${estabelecimento.nome}`,
                  value: estabelecimento.cnpj,
                  cnpj: this.formataCNPJ(estabelecimento.cnpj),
                  razao: estabelecimento.nome,
                };
              }
            );
          this.carregando = false;
        })
        .catch((error) => {
          console.log(error);
          this.carregando = false;
        });
    },

    confirmarCancelamento: async function () {
      this.carregando = true;
      this.mensagemCancelamento = [];

      const lancamentosCancelamento = this.lancamentosCancelamento.map(
        (lancamento) => lancamento.ID_LANCAMENTO
      );

      const informacaoCancelamento = { lancamentosCancelamento };

      await axios
        .post(this.$env.url_backend + constantes.confirmarCancelamento, {
          informacaoCancelamento,
        })
        .then((response) => {
          const retorno = response.data[0];

          this.informacoesCancelamento.cpfCnpj =
            this.informacaoContribuinte.cadastroNacional;

          this.informacoesCancelamento.razaoSocial =
            this.informacaoContribuinte.nome;

          if (retorno.AMENSAGEM === "OK") {
            this.informacoesCancelamento.confirmacao = retorno.ACONFIRMACAO;
            this.informacoesCancelamento.dadosExibicao = retorno.ADADOSEXIBICAO;
            this.informacoesCancelamento.listaParcelamento =
              retorno.ALISTAPARCTOS;
            this.carregando = false;
          } else {
            this.mensagemCancelamento.push(response.data.AMENSAGEM);
            this.carregando = false;
          }
        })
        .catch(() => {
          this.carregando = false;
          this.mostrarConfirmacaoCancelamento = false;
        });
    },

    finalizarCancelamento: async function () {
      this.mensagemCancelamento = [];
      this.bloquearExibirLancamentos = false;
      if (
        this.informacoesCancelamento.codigoCancelamento ===
        this.informacoesCancelamento.confirmacao
      ) {
        this.fecharModal("modal-cancelamento");
        this.bloqueioCancelamento = false;
        this.bloquearExibirLancamentos = true;
        await this.retornaCalculos();
      } else {
        this.bloqueioCancelamento = true;
        this.mensagemCancelamento.push("O código inserido está incorreto.");
      }
    },

    guiaParcelamento: async function (informacaoGuia) {
      this.mensagemParcelamento = [];
      this.carregando = true;

      if (this.origemAcesso !== "GovBr" && this.origemAcesso !== "AD")
         informacaoGuia.usuario = "";

      await axios
        .post(this.$env.url_backend + constantes.retornaGuiaParcelamentos, {
          informacaoGuia,
        })
        .then((response) => {
          const retorno = response.data;
          if (retorno[0].AMENSAGEM === "OK") {
            const url = retorno[0].AURLEMISSAO;

            window.open(url, "_blank");
            this.carregando = false;
          } else {
            this.mensagemParcelamento.push(
              "Houve um erro ao gerar o DRAM de parcelamento."
            );
            this.carregando = false;
          }
        })
        .catch(() => {
          this.carregando = false;
          this.fecharModal("modal-parcelamento");
          this.corMensagem = "danger";
          this.iconMensErro = "x-circle-fill";
          this.carregaListaMensagensErros("PÁGINA EM MANUTENÇÃO, FAVOR ACESSAR MAIS TARDE.");
          window.scrollTo(0, 0);
        });
    },

    simularPagamento: async function () {
      this.mensagemErro = [];

      this.carregando = true;

      const lancamentos = this.lancamentosSelecionados.map(
        (lancamento) => lancamento.ID_LANCAMENTO
      );

      await axios
        .post(this.$env.url_backend + constantes.imprimeSimulacao, {
          lancamentosSelecionados: lancamentos,
        })
        .then((response) => {
          const retorno = response.data;
          const url = retorno[0];
          const link = url.startsWith("http://") ? url : `http://${url}`;

          window.open(link, "_blank");
          this.carregando = false;
        })
        .catch(() => {
          this.corMensagem = "danger";
          this.iconMensErro = "x-circle-fill";
          this.carregaListaMensagensErros("PÁGINA EM MANUTENÇÃO, FAVOR ACESSAR MAIS TARDE.");
          this.fecharModal("modal-lancamentos");
          window.scrollTo(0, 0);
          this.carregando = false;
        });
    },

    guiaPagamentoAVista(valor) {
      if (valor === "cessao")
        window.open(this.calculos.GUIA_VISTA_CESSAO, "_blank");
      if (valor === "demais")
        window.open(this.calculos.GUIA_VISTA_DEMAIS, "_blank");
    },

    limparDadosTabela: function (dados) {
      this.limparInformacoesTabela();

      this.lancamentosSelecionados = [];
      this.lancamentosCancelamento = [];

      this.calculos = {
        OPCOES_PARCTO_CESSAO: [],
        OPCOES_PARCTO_DEMAIS: [],
        LANCAMENTO_CESSAO: [],
        LANCAMENTO_DEMAIS: [],
      };

      this.lancamentos = dados.ALANCAMENTOS;
      this.bloquearExibirLancamentos = false;
    },

    limparInformacoesTabela: function () {
      this.permitirCancelar = false;
      this.bloqueioCancelamento = false;
    },

    formatCurrency: function (value) {
      let formatter = new Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency: "BRL",
        minimumFractionDigits: 2,
      });
      return formatter.format(value);
    },

    formatCPFCNPJ(value) {
      if (value === "0") return "Identificador não encontrado";
      if (!value) return "";
      else {
        value = value.replace(/[^\d]+/g, "");

        if (value.length === 11) {
          value = value.replace(/(\d{3})(\d{3})(\d{3})(\d{2})$/, "$1.$2.$3-$4");
          return value;
        } else if (value.length === 14) {
          value = value.replace(
            /(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/,
            "$1.$2.$3/$4-$5"
          );
          return value;
        }
      }
    },

    reinicializaIdentificador: function () {
      this.mensagemValidacaoIdentificador = "";
      this.dadosContribuinte.Identificador = "";
      this.dadosContribuinte.razaoSocial = "";
      this.dadosContribuinte.cadastroNacional = "";
      this.dadosContribuinte.identificador = "";
      this.dadosContribuinte.numeroParcelamento = "";
      this.dadosContribuinte.placaVeiculo = "";
      this.dadosContribuinte.codigoLancamento = "";
      this.dadosContribuinte.processoJudicial = "";
      this.dadosContribuinte.transacao = "";      
      this.preencheIdentificadorOK = false;
      //INSCRICAO MUNICIPAL
      if (this.dadosContribuinte.tipoIdentificador === 1) {
        this.placeHolderIdentificador = "Informe a Inscrição Municipal";
      }
      //CPF
      if (this.dadosContribuinte.tipoIdentificador === 3) {
        this.placeHolderIdentificador = "Informe o CPF";
      }
      //CNPJ
      if (this.dadosContribuinte.tipoIdentificador === 4) {
        this.placeHolderIdentificador = "Informe o CNPJ";
      }
      //perpetuidade
      if (this.dadosContribuinte.tipoIdentificador === 5) {
        this.placeHolderIdentificador = "Informe a Perpetuidade";
      }
      //PARCELAMENTO
      if (this.dadosContribuinte.tipoIdentificador === 14) {
        this.placeHolderIdentificador = "Informe o Parcelamento / ano";
      }
      //PROCESSO JUDICIAL
      if (this.dadosContribuinte.tipoIdentificador === 15) {
        this.placeHolderIdentificador = "Informe o Processo Judicial";
      }
      //ÍNDICE CADASTRAL
      if (this.dadosContribuinte.tipoIdentificador === 8) {
        this.placeHolderIdentificador = "Informe o Índice Cadastral";
      }
      //PLACA DE VEÍCULO
      if (this.dadosContribuinte.tipoIdentificador === 10) {
        this.placeHolderIdentificador = "Informe a Placa do Veículo";
      }
      //TRANSAÇAO
      if (this.dadosContribuinte.tipoIdentificador === 16) {
        this.placeHolderIdentificador = "Informe a Transação de ITBI / ano";
      }

      this.dadosContribuinte.identificador = "";
      this.mascaraIdentificador = {};
      this.habilitarCampos();
      this.focusInput("identificador");
    },

    getSelecionados(data) {
      if (data.title === "lancamentos")
        this.lancamentosSelecionados = data.selecionados;

      this.lancamentosCancelamento = this.lancamentosSelecionados.filter(
        (lancamento) => lancamento.NUMERO_PARCELAMENTO !== null
      );

      if (this.lancamentosCancelamento.length > 0) {
        this.bloqueioCancelamento = true;
        this.permitirCancelar = true;
      } else {
        this.bloqueioCancelamento = false;
        this.permitirCancelar = false;
      }
    },
    desabilitarCampos() {
      if (this.dadosContribuinte.cadastroNacional.length > 0) {
        this.dadosContribuinte.numeroParcelamento = "";
        this.dadosContribuinte.identificador = "";
        this.dadosContribuinte.tipoIdentificador = "";

        this.desabilitaParcelamento = true;
        this.desabilitaIdentificador = true;
      } else if (this.dadosContribuinte.identificador.length > 0) {
        this.dadosContribuinte.numeroParcelamento = "";
        this.dadosContribuinte.cadastroNacional = "";

        this.desabilitaParcelamento = true;
        this.desabilitacodigoNacional = true;
      } else if (this.dadosContribuinte.numeroParcelamento.length > 0) {
        this.dadosContribuinte.cadastroNacional = "";
        this.dadosContribuinte.tipoIdentificador = "";
        this.dadosContribuinte.identificador = "";

        this.desabilitacodigoNacional = true;
        this.desabilitaIdentificador = true;
      } else {
        this.habilitarCampos();
      }
    },

    habilitarCampos() {
      this.desabilitacodigoNacional = false;
      this.desabilitaIdentificador = false;
      this.desabilitaParcelamento = false;
      this.bloquearExibirLancamentos = false;
    },

    limparMensagensDeErro() {
      this.mensagemErro = [];
      this.mensagemLancamentos = [];
      this.informativoSelecao = false;

      this.mensagemParcelamento = [];
      this.mostrarMensagemDebitosInexistentes = false;

      this.erroValidacaoCPFCNPJ = "";
      this.mensagemValidacaoCPFCNPJ = "";

      this.erroValidacaoIdentificador = "";
      this.mensagemValidacaoIdentificador = "";

      this.erroValidacaoParcelamento = "";
      this.mensagemValidacaoParcelamento = "";

      this.erroValidacaoCodigoParcelamento = "";
      this.mensagemValidacaoCodigoParcelamento = "";

      this.erroValidacaoPlacaVeiculo = "";
      this.mensagemValidacaoPlacaVeiculo = "";

      this.erroValidacaoLancamento = "";
      this.mensagemValidacaoLancamento = "";
    },

    limparCamposParcelamento: function () {
      this.mensagemParcelamento = [];

      this.escolhaDemaisParcelamentos = "";
      this.mostrarDemais = false;

      this.escolhaCessao = "";
      this.mostrarCessao = false;

      this.informacaoParcelamento.email = "";
      this.informacaoParcelamento.telefone = "";
      this.bloquearExibirLancamentos = false;
    },

    preencheIdentificador: function () {
      let tam = 0;
      let mensErro = "";
      let textColor = "";
      let opcao = "";
      if (this.dadosContribuinte.identificador.length > 0) {
        //inscrição municipal
        if (this.dadosContribuinte.tipoIdentificador === 1) {
          tam = 15;
          opcao = "INSCRIÇÃO MUNICIPAL";
        }
        //CPF
        if (this.dadosContribuinte.tipoIdentificador === 3) {
          tam = 14;
          opcao = "CPF";
        }
        //CNPJ
        if (this.dadosContribuinte.tipoIdentificador === 4) {
          tam = 18;
          opcao = "CNPJ";
        }
        //perpetuidade
        if (this.dadosContribuinte.tipoIdentificador === 5) {
          tam = 2;
          opcao = "PERPETUIDADE";
        }
        //PARCELAMENTO
        if (this.dadosContribuinte.tipoIdentificador === 14) {
          tam = 5;
          opcao = "PARCELAMENTO";
          this.dadosContribuinte.identificador =
            this.formataParcelamentoTransacao(
              this.dadosContribuinte.identificador
            );
        }
        //PROCESSO JUDICIAL
        if (this.dadosContribuinte.tipoIdentificador === 15) {
          tam = 20;
          opcao = "PROCESSO JUDICIAL";
        }
        //ÍNDICE CADASTRAL
        if (this.dadosContribuinte.tipoIdentificador === 8) {
          tam = 19;
          opcao = "ÍNDICE CADASTRAL";
        }
        //PLACA DE VEÍCULO
        if (this.dadosContribuinte.tipoIdentificador === 10) {
          tam = 8;
          opcao = "PLACA DE VEÍCULO";
        }
        //TRANSAÇAO
        if (this.dadosContribuinte.tipoIdentificador === 16) {
          tam = 5;
          opcao = "TRANSAÇÃO";
          this.dadosContribuinte.identificador =
            this.formataParcelamentoTransacao(
              this.dadosContribuinte.identificador
            );
        }

        if (this.dadosContribuinte.tipoIdentificador === 16) {
          mensErro =
            this.dadosContribuinte.identificador.length >= tam
              ? opcao + " digitada é válida"
              : opcao + " digitada está incompleta";
        } else {
          mensErro =
            this.dadosContribuinte.identificador.length >= tam
              ? opcao + " digitado(a) é válido(a)"
              : opcao + " digitado(a) está incompleto(a)";
        }
        textColor =
          this.dadosContribuinte.identificador.length >= tam
            ? "text-success"
            : "text-danger";
        this.preencheIdentificadorOK =
          this.dadosContribuinte.identificador.length >= tam;
        if (this.dadosContribuinte.identificador.length >= tam) {
          /// inscricao municipal
          if (this.dadosContribuinte.tipoIdentificador === 1) {
            if (
              this.validarInscricaoMunicipal(
                this.dadosContribuinte.identificador
              )
            ) {
              mensErro = opcao + " digitado(a) é válido(a)";
              textColor = "text-success";
              this.preencheIdentificadorOK = true;
            } else {
              mensErro = opcao + " - dígito verificador inválido";
              textColor = "text-danger";
              this.preencheIdentificadorOK = false;
            }
          }
          // indice cadastral
          if (this.dadosContribuinte.tipoIdentificador === 8) {
            if (this.validarIPTU(this.dadosContribuinte.identificador)) {
              mensErro = opcao + " digitado(a) é válido(a)";
              textColor = "text-success";
              this.preencheIdentificadorOK = true;
            } else {
              mensErro = opcao + " - dígito verificador inválido";
              textColor = "text-danger";
              this.preencheIdentificadorOK = false;
            }
          }
          // cnpj
          if (this.dadosContribuinte.tipoIdentificador === 4) {
            if (validarCNPJ(this.dadosContribuinte.identificador)) {
              mensErro = opcao + " digitado(a) é válido(a)";
              textColor = "text-success";
              this.preencheIdentificadorOK = true;
            } else {
              mensErro = opcao + " - dígito verificador inválido";
              textColor = "text-danger";
              this.preencheIdentificadorOK = false;
            }
          }
          // cpf
          if (this.dadosContribuinte.tipoIdentificador === 3) {
            if (validarCPF(this.dadosContribuinte.identificador)) {
              mensErro = opcao + " digitado(a) é válido(a)";
              textColor = "text-success";
              this.preencheIdentificadorOK = true;
            } else {
              mensErro = opcao + " - dígito verificador inválido";
              textColor = "text-danger";
              this.preencheIdentificadorOK = false;
            }
          }
        }
        // this.desabilitaBtnPesquisar = this.preencheIdentificadorNOK;
        this.desabilitarCampos();
        this.erroValidacaoIdentificador = textColor;
        this.mensagemValidacaoIdentificador = mensErro;
      }
      if (this.dadosContribuinte.identificador === "") {
        this.mensagemValidacaoIdentificador = "";
      }
      if (this.dadosContribuinte.cadastroNacional === "") {
        this.mensagemValidacaoCPFCNPJ = "";
      }
    },

    validarIPTU: function (iptu) {
      iptu = iptu.replace(/[^\d \w]+/g, "").trim();
      if (iptu.length !== 15) return false;

      iptu = iptu.split("");
      const valores = [3, 2, 7, 6, 5, 4, 3, 2, 7, 6, 5, 4, 3, 2];
      const posicoes = [6, 10, 11];

      let soma = 0;

      for (let index = 0; index < valores.length; index++) {
        let digito = iptu[index];
        if (posicoes.includes(index)) {
          soma += this.retornoNumeroCorrespondente(digito) * valores[index];
        } else {
          soma += digito * valores[index];
        }       
      }
      const resto = soma % 11;      
      let ultimoDigito = "";
      if (resto === 0) {
        ultimoDigito = "X";
      } else if (resto === 1) {
        ultimoDigito = "0";
      } else {
        ultimoDigito = 11 - resto;
      }
      return iptu[14] === ultimoDigito.toString();
    },

    retornoNumeroCorrespondente: function (val) {
      let letra = val.toUpperCase();
      if (letra === " ") return 0;
      else if (letra == "A" || letra == "J") return 1;
      else if (letra == "B" || letra == "K" || letra == "S") return 2;
      else if (letra == "C" || letra == "L" || letra == "T") return 3;
      else if (letra == "D" || letra == "M" || letra == "U") return 4;
      else if (letra == "E" || letra == "N" || letra == "V") return 5;
      else if (letra == "F" || letra == "O" || letra == "W") return 6;
      else if (letra == "G" || letra == "P" || letra == "X") return 7;
      else if (letra == "H" || letra == "Q" || letra == "Y") return 8;
      else if (letra == "I" || letra == "R" || letra == "Z") return 9;
      else return parseInt(letra);
      /*
            else if (letra.includes("A", "J")) return 1;
            else if (letra.includes("B", "K", "S")) return 2;
            else if (letra.includes("C", "L", "T")) return 3;
            else if (letra.includes("D", "M", "U")) return 4;
            else if (letra.includes("E", "N", "V")) return 5;
            else if (letra.includes("F", "O", "W")) return 6;
            else if (letra.includes("G", "P", "X")) return 7;
            else if (letra.includes("H", "Q", "Y")) return 8;
            else if (letra.includes("I", "R", "Z")) return 9;
            else return parseInt(letra);
      */
    },

    validarInscricaoMunicipal: function (inscricaoMunicipal) {
      inscricaoMunicipal = inscricaoMunicipal.replace(/[^\dxX]+/g, "");

      const sequencial = [3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
      let identificadorSemDigitoVerificador = "";
      let soma = 0;
      if (inscricaoMunicipal.length < 10)
        identificadorSemDigitoVerificador = inscricaoMunicipal
          .substring(0, 9)
          .padStart(10, "0");
      else if (inscricaoMunicipal.length === 10)
        if (inscricaoMunicipal.substring(0, 1) === "0")
          identificadorSemDigitoVerificador = inscricaoMunicipal
            .substring(1, 9)
            .padStart(10, "0");
        else if (Number(inscricaoMunicipal.substring(11, 1)))
          identificadorSemDigitoVerificador = inscricaoMunicipal;
        else
          identificadorSemDigitoVerificador = inscricaoMunicipal
            .substring(0, 9)
            .padStart(10, "0");
      else
        identificadorSemDigitoVerificador = inscricaoMunicipal
          .padStart(11, "0")
          .substring(0, 10);
      for (let i = 0; i < identificadorSemDigitoVerificador.length; i++)
        soma += Number(identificadorSemDigitoVerificador[i] * sequencial[i]);

      let resto = soma % 11;

      inscricaoMunicipal = inscricaoMunicipal.padStart(10, "0");
      const digitoVerificador =
        resto === 0 ? "0" : resto === 1 ? "X" : 11 - resto;
      identificadorSemDigitoVerificador += digitoVerificador;

      return inscricaoMunicipal === identificadorSemDigitoVerificador;
    },

    validacaoIdentificador: function () {
      if (this.dadosContribuinte.tipoIdentificador === 1) {
        //inscrição municipal
        this.mascaraIdentificador = {
          mask: "#.###.###/###-J",
          tokens: this.tokens,
        };
      }

      if (this.dadosContribuinte.tipoIdentificador === 3) {
        // CPF
        this.mascaraIdentificador = {
          mask: "###.###.###-##",
          tokens: this.tokens,
        };
      }

      if (this.dadosContribuinte.tipoIdentificador === 4) {
        // CNPJ
        this.mascaraIdentificador = {
          mask: "##.###.###/####-##",
          tokens: this.tokens,
        };
      }

      if (this.dadosContribuinte.tipoIdentificador === 5) {
        // PERPETUIDADE
        this.mascaraIdentificador = {
          mask: "##############",
          tokens: this.tokens,
        };
      }

      if (this.dadosContribuinte.tipoIdentificador === 15) {
        // PROCESSO JUDICIAL
        this.mascaraIdentificador = {
          mask: "####################",
          tokens: this.tokens,
        };
      }

      if (this.dadosContribuinte.tipoIdentificador === 14) {
        // PARCELAMENTO
        this.mascaraIdentificador = {
          mask: "#######/####",
          tokens: this.tokens,
        };
      }

      if (this.dadosContribuinte.tipoIdentificador === 8) {
        // INDICE CADASTRAL
        this.mascaraIdentificador = {
          mask: "###.###E.###E.X##.J",
          tokens: this.tokens,
        };
      }

      if (this.dadosContribuinte.tipoIdentificador === 10) {
        // PLACA DE VEICULO
        this.mascaraIdentificador = {
          mask: "LLL-#X##",
          tokens: this.tokens,
        };
      }

      if (this.dadosContribuinte.tipoIdentificador === 16) {
        // TRANSACAO
        this.mascaraIdentificador = {
          mask: "#######/####",
          tokens: this.tokens,
        };
      }
      this.desabilitarCampos();
    },

    formataParcelamentoTransacao: function (valor) {
      valor = valor + "";
      valor = parseInt(valor.replace(/[\D]+/g, ""));
      valor = valor + "";
      if (valor.length > 4) {
        valor = valor.replace(/([0-9]{4})$/g, "/$1");
      }
      if (valor == "NaN") {
        valor = "";
      }
      return valor;
    },

    validacaoParcelamento: function () {
      const anoAtual = new Date().getFullYear();
      const numeroParcelamento = this.dadosContribuinte.numeroParcelamento;
      const anoParcelamento = numeroParcelamento.substring(
        8,
        numeroParcelamento.length
      );

      let erro = "";
      let textColor = "";

      if (anoParcelamento > anoAtual) {
        erro =
          "O ano em que foi feito o parcelamento não pode ser maior que o ano atual";
        textColor = "text-danger";
      }

      this.desabilitarCampos();
      this.erroValidacaoParcelamento = textColor;
      this.mensagemValidacaoParcelamento = erro;
    },

    verificaPreenchimento() {
      if (this.dadosContribuinte.identificador === "") {
        this.mensagemValidacaoIdentificador = "";
      }
      if (this.dadosContribuinte.cadastroNacional === "") {
        this.mensagemValidacaoCPFCNPJ = "";
      }
      let opc = false;
      if (
        this.dadosContribuinte.cadastroNacional === "" &&
        this.dadosContribuinte.identificador === ""
      ) {
        opc = false;
      } else if (
        this.dadosContribuinte.cadastroNacional === "" &&
        this.dadosContribuinte.identificador != ""
      ) {
        opc = this.preencheIdentificadorOK;
      } else if (
        this.dadosContribuinte.cadastroNacional != "" &&
        this.dadosContribuinte.identificador === ""
      ) {
        opc = this.preencheCpfCnpjOK;
      } else {
        opc = this.preencheIdentificadorOK && this.preencheCpfCnpjOK;
      }
      return !opc;
    },
    /*    
    validacaoCPFCNPJ: function () {
      let erro = "";
      let textColor = "";

      if (this.dadosContribuinte.cadastroNacional.length > 0) {
        if (validarCpfCnpj(this.dadosContribuinte.cadastroNacional)) {
          textColor = "text-success";
          erro = "O CPF/CNPJ digitado é válido";
        } else if (this.dadosContribuinte.cadastroNacional.length > 0) {
          textColor = "text-danger";
          erro = "O CPF/CNPJ digitado não é valido";
        }
      }

      this.desabilitarCampos();
      this.erroValidacaoCPFCNPJ = textColor;
      this.mensagemValidacaoCPFCNPJ = erro;
    },
*/
    validacaoCPFCNPJ: function () {
      let tamCampo = 0;
      let txt = "";
      let formato = "";
      let tipo = this.dadosContribuinte.cadastroNacional.length;
      this.preencheCpfCnpjOK = false;

      //CPF
      if (tipo <= 14) {
        tamCampo = 14;
        txt = "CPF";
      } else {
        //CNPJ
        tamCampo = 18;
        txt = "CNPJ";
      }

      if (this.dadosContribuinte.cadastroNacional.length <= tamCampo) {
        this.mensagemValidacaoCPFCNPJ = txt + " digitado está incompleto";
        formato = "text-danger";
        this.preencheCpfCnpjOK = false;
      }
      if (tipo == 14) {
        if (validarCPF(this.dadosContribuinte.cadastroNacional)) {
          this.mensagemValidacaoCPFCNPJ = txt + " digitado é válido";
          formato = "text-success";
          this.preencheCpfCnpjOK = true;
        } else {
          this.mensagemValidacaoCPFCNPJ =
            txt + " - dígito verificador inválido";
          formato = "text-danger";
          this.preencheCpfCnpjOK = false;
        }
      }
      // cnpj
      else if (tipo == 18) {
        if (validarCNPJ(this.dadosContribuinte.cadastroNacional)) {
          this.mensagemValidacaoCPFCNPJ = txt + " digitado é válido";
          formato = "text-success";
          this.preencheCpfCnpjOK = true;
        } else {
          this.mensagemValidacaoCPFCNPJ =
            txt + " - dígito verificador inválido";
          formato = "text-danger";
          this.preencheCpfCnpjOK = false;
        }
      }
      this.erroValidacaoCPFCNPJ = formato;

      if (this.dadosContribuinte.identificador === "") {
        this.mensagemValidacaoIdentificador = "";
      }
      if (this.dadosContribuinte.cadastroNacional === "") {
        this.mensagemValidacaoCPFCNPJ = "";
      }
    },

    limparCampos: function () {
      this.limparMensagensDeErro();

      this.mostrarDemaisInformacoes = false;
      this.mostrarErroMuitosLancamentos = false;
      this.dadosContribuinte.razaoSocial = "";
      this.dadosContribuinte.tipoIdentificador = "";
      this.dadosContribuinte.cadastroNacional = "";
      this.dadosContribuinte.identificador = "";
      this.dadosContribuinte.numeroParcelamento = "";

      if (this.origemAcesso === "GovBr") {
        this.dadosContribuinte.cadastroNacional = this.$store.getters.userInfo.preferred_username;
        if (this.dadosContribuinte.cadastroNacional.length === 11) {
          this.dadosContribuinte.cadastroNacional = this.formataCPF(this.dadosContribuinte.cadastroNacional);
        } else {
          this.dadosContribuinte.cadastroNacional = this.formataCNPJ(this.dadosContribuinte.cadastroNacional);
        }
        this.dadosContribuinte.nomeContribuinte = this.$store.getters.userInfo.name.toUpperCase();
      } else {
        this.dadosContribuinte.cadastroNacional = "";
        this.dadosContribuinte.nomeContribuinte = "";
      } 
      
      this.cnpjSelecionado = "";
      
      this.calculos = {
        OPCOES_PARCTO_CESSAO: [],
        OPCOES_PARCTO_DEMAIS: [],
        LANCAMENTO_CESSAO: [],
        LANCAMENTO_DEMAIS: [],
      };

      this.habilitarCampos();
    },

    abrirModal: function (referencia) {
      this.$refs[referencia].show();
    },

    abrirModalPagamentoAVistaSeNecessario: function (referencia) {
      this.fecharModal("dialog-confirmar-a-vista");

      if (this.calculos.GUIA_VISTA_CESSAO && this.calculos.GUIA_VISTA_DEMAIS)
        this.$refs[referencia].show();
      else {
        if (this.calculos.GUIA_VISTA_CESSAO) this.guiaPagamentoAVista("cessao");
        if (this.calculos.GUIA_VISTA_DEMAIS) this.guiaPagamentoAVista("demais");
      }
    },

    mostrarModalParcelamento: function () {
      if (
        this.calculos.OPCOES_PARCTO_CESSAO &&
        this.calculos.OPCOES_PARCTO_DEMAIS.length > 0
      )
        this.$refs["modal-confirmar-parcelamento"].show();
      else {
        if (this.calculos.OPCOES_PARCTO_CESSAO) 
          this.abrirModalParcelamentoSeNecessario("cessao"); 
        else if (this.calculos.OPCOES_PARCTO_DEMAIS.length > 0)
              this.abrirModalParcelamentoSeNecessario("demais"); 
        else{  
           this.fecharModal("dialog-confirmar-parcelamento");  
           const msg = "O valor total para pagamento não permite parcelamento devido ao valor mínimo exigido para a parcela. Emitir DRAM para pagamento à vista";
           this.corMensagem = "danger";
           this.carregaListaMensagensErros(msg);
        }   
      }
    },

    abrirModalParcelamentoSeNecessario: function (tipoLancamento) {
      this.fecharModal("dialog-confirmar-parcelamento");

      if (tipoLancamento === "cessao") {
        this.mostrarCessao = true;
        this.mostrarDemais = false;
        this.$refs["modal-parcelamento"].show();
      }

      if (tipoLancamento === "demais") {
        this.mostrarCessao = false;
        this.mostrarDemais = true;
        this.$refs["modal-parcelamento"].show();
      }
    },

    abrirDialogPagamentoAVista() {
      if (
        this.lancamentosSelecionados.length !==
        this.orgaoCobranca.ALANCAMENTOS.length
      )
        this.$refs["dialog-confirmar-a-vista"].show();
      else
        this.abrirModalPagamentoAVistaSeNecessario("modal-pagamento-a-vista");
    },

    abrirDialogParcelamento() {
      if (
        this.lancamentosSelecionados.length !==
        this.orgaoCobranca.ALANCAMENTOS.length
      )
        this.$refs["dialog-confirmar-parcelamento"].show();
      else this.mostrarModalParcelamento();
    },

    fecharModal: function (referencia) {
      this.$refs[referencia].hide();
    },

    retirarMensagensTela: function () {
      this.mensagemSucesso = [];
      this.mensagemErro = [];
      this.mensagemLancamentos = [];
      this.informativoSelecao = false;
      this.mensagemParcelamento = [];
      this.mensagemCancelamento = [];
      this.mensagemCancelamentoSucesso = [];

      this.mensagemValidacaoCPFCNPJ = "";
      this.erroValidacaoCPFCNPJ = "";
      this.mensagemValidacaoIdentificador = "";
      this.erroValidacaoIdentificador = "";
      this.mensagemValidacaoParcelamento = "";
      this.erroValidacaoParcelamento = "";
    },
    identificadoresSemAutenticacao() {
      const identificadoresFiltrados = this.opcoesIdentificador.filter(
        (elemento) => {
          // TODO: Remover quando for implementado a autenticação

          return (
            elemento.text !== "TRANSACAO DE ITBI" &&
            elemento.text !== "PLACA VEICULO"
          );
        }
      );

      this.opcoesIdentificador = identificadoresFiltrados;
    },
  },
  created() {
    this.cabecalhoLancamento = this.cabecalhoLancamento.map((atributo) => {
      return {
        key: atributo.nomeInterno,
        label: atributo.nomeExterno,
        formatter: atributo.formatter,
        sortable: atributo.sortable,
      };
    });

    this.cabecalhoCancelamento = this.cabecalhoCancelamento.map((atributo) => {
      return {
        key: atributo.nomeInterno,
        label: atributo.nomeExterno,
        formatter: atributo.formatter,
        sortable: atributo.sortable,
      };
    });
  },

  async beforeMount() {
    this.userName = this.$store.getters.userInfo.preferred_username;
    this.origemAcesso = this.$store.getters.userInfo.origem;
    if (this.origemAcesso === "GovBr") {
      this.dadosContribuinte.cadastroNacional = this.userName;
      this.dadosContribuinte.nomeContribuinte = this.$store.getters.userInfo.name.toUpperCase();
      // this.desabilitaBtnPesquisar = false;
      this.preencheCpfCnpjOK = true;
      await this.buscarCNPJSRelacionados();
    }
  },
    
  async mounted() {
    // if (this.origemAcesso === "AD") {
    //   this.focusInput("cpfCnpj");
    // } else {
    //   this.focusInput("tipoCertidao");
    // }
//

    await axios
      .get(this.$env.url_backend + constantes.tiposDeIdentificadores, {})
      .then((response) => {
        const options = response.data;

        options.map((option) => {
          this.opcoesIdentificador.push({
            text: option.DESCRICAO,
            value: option.ID_TIPO_IDENTIFICADOR,
            disabled: false,
            hidden: false,
          });
        });

        this.opcoesIdentificador.unshift({
          text: "SELECIONE",
          value: "",
          selected: true,
          disabled: true,
          hidden: true,
        });
      })
      .catch((error) => {
        console.log(error);
        this.corMensagem = "danger";
        this.iconMensErro = "x-circle-fill";
        this.carregaListaMensagensErros("PÁGINA EM MANUTENÇÃO, FAVOR ACESSAR MAIS TARDE.");
        window.scrollTo(0, 0);
      })
      .finally(() => {
        this.identificadoresSemAutenticacao();
      });
  },
};
</script>

<style lang="css" scoped>
.container {
  min-width: 90%;
  max-width: 90%;
}

::v-deep .small-modal .modal-dialog {
  width: 30%;
  max-width: 50%;
}

::v-deep .modal-dialog {
  width: 95%;
  max-width: 100%;
}

#btnTopo {
  display: none;
  position: fixed;
  bottom: 20px;
  right: 30px;
  z-index: 9999;
  border: none;
  outline: none;
  background-color: red;
  color: white;
  cursor: pointer;
  padding: 15px;
  border-radius: 10px;
}

#btnTopo:hover {
  background-color: #555;
}

</style>
